import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeSliderListComponent } from './home-slider-list/home-slider-list.component';
import { HomeSliderCreateComponent } from './home-slider-create/home-slider-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: HomeSliderListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: HomeSliderCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'home-slider-create/:id',
        component: HomeSliderCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomeSliderRoutingModule { }
